import script from "./PandoraCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraCalendar.vue?vue&type=script&setup=true&lang=js"

import "./PandoraCalendar.vue?vue&type=style&index=0&id=0c618202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c618202"]])

export default __exports__